import { ECurecallGradientName } from '@honestica/curecall-ui'
import { EMedEventTypes, TMedEventUI } from './med-event'
import { TLabel } from './locales'
import { TMedicalStaffMember } from './medical-staff-member'
import { TDeprecatedPatientVariable } from './variable'

export type TValidationRule = {
  type: EMedEventTypes
  max?: number
  min?: number
}

export type TConfigUI = {
  followupUI: {
    card?: { gradientName: ECurecallGradientName }
    form?: {
      textIntro?: TLabel
      disclaimer?: TLabel
    }
    patientDetails?: {
      tabTitle?: TLabel
      textIntro?: TLabel
      templateName?: string
      isHiddenOnPatientFile?: boolean
      includeGoodToKnowAttr?: boolean
    }
  }
  medEventsUI: TMedEventUI[]
  validationRules?: TValidationRule[]
  patientVariables?: TDeprecatedPatientVariable[]
}

export type TFollowup = {
  id: number
  ProjectId: number
  name: string
  description: string
  configUI: TConfigUI
  idleDaysBeforeFollowupEnd: number
  position: number
  deletedAt?: string
}

export enum EEndReason {
  PATIENT_DEATH = 'PATIENT_DEATH',
  PATIENT_HOSPITALISED = 'PATIENT_HOSPITALISED',
  FINISHED = 'FINISHED',
  OTHER = 'OTHER',
}

export type TPatientFollowup = {
  id: number
  startDate: string
  endAt?: string
  endReason?: EEndReason
  reportAvailable: boolean
  PatientId: number
  MedicalStaffMemberId: number
  MedicalStaffMember?: TMedicalStaffMember
  activeTab?: boolean
  configUI?: TConfigUI
  type?: string
  createdAt: string
  FollowupId: number
  Followup: TFollowup
}
